<script setup lang="ts">
import { defineProps } from "vue";
import router from "@/router";

const handleClick = () => {
  router.push("/services").then(() => {
    // 定位到顶部
    window.scrollTo(0, 0);
  });
};

const props = defineProps({
  // 文字
  text: String,
  // icon
  icon: String,
});
</script>

<template>
  <div class="box-container">
    <i :class="props.icon" style="font-size: 50px; color: #fff" />
    <div class="box-font">{{ props.text }}</div>
    <div class="customer-button" @click="handleClick">→</div>
  </div>
</template>

<style scoped>
.box-container {
  width: 280px;
  height: 350px;
  background-color: #609ee9;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.box-container i :hover {
  font-size: 70px;
}

.customer-button {
  height: 35px;
  width: 60px;
  font-size: 40px;
  color: #fff;
  border-bottom: 1px solid #fff;
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.customer-button:hover {
  background-color: #fff;
  color: #1364e9;
  cursor: pointer;
}

.box-font {
  color: #fff;
  font-size: 20px;
  margin-top: 30px;
}
</style>
